<script>
export default {
  name: "CalculateButton",
  inject: [ 'store'],
  props: ["scrollto"]
}
</script>

<template>
  <button class="btn btn-primary btn-form w-100 loading_btn">{{ store.calcTitles.calc_button }}
    <span v-if="store.loading" class="spinner-border text-success" role="status">
    </span>
  </button>
</template>